SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportEditOrderServiceActionView extends SupportServiceActionsBaseView
  id: 'edit_order'

  initialize: ->
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : "edit_order",
      service_action : I18n.t("js.modules.support.edit_order")
    @extendHash(hash)

  actionHandler: (event) ->
    current_order = Groupon.Support.currentOrder

    dealPermalink = current_order.deal.id
    orderId = current_order.id
    url = "/deals/#{ dealPermalink }/confirmation/#{ orderId }"
    window.open(url)

  events:
    "click #edit_order" : "actionHandler"

module.exports = SupportEditOrderServiceActionView
